import { defaultStatus } from '../defaultState/defaultState'
import {
  ADD_PATIENT_FAILURE,
  ADD_PATIENT_REQUEST,
  ADD_PATIENT_SUCCESS,
  DELETE_PATIENT_FAILURE,
  DELETE_PATIENT_REQUEST,
  DELETE_PATIENT_SUCCESS,
  FETCH_ALL_LIST_PATIENTS_FAILURE,
  FETCH_ALL_LIST_PATIENTS_REQUEST,
  FETCH_ALL_LIST_PATIENTS_SUCCESS,
  FETCH_LIST_PATIENTS_FAILURE,
  FETCH_LIST_PATIENTS_REQUEST,
  FETCH_LIST_PATIENTS_SUCCESS,
  FETCH_PATIENT_FAILURE,
  FETCH_PATIENT_REQUEST,
  FETCH_PATIENT_SUCCESS,
  HISTORY_PATIENTS_FAILURE,
  HISTORY_PATIENTS_REQUEST,
  HISTORY_PATIENTS_SUCCESS,
  RESET_CURRENT_PATIENT,
  UPDATE_PATIENT_FAILURE,
  UPDATE_PATIENT_REQUEST,
  UPDATE_PATIENT_SUCCESS
} from './patientType'

const initialState = {

  addPatient: { ...defaultStatus },
  deletePatient: { ...defaultStatus },
  fetchListPatients: { ...defaultStatus },
  fetchAllListPatients: { ...defaultStatus },
  fetchPatient: { ...defaultStatus },
  updatePatient: { ...defaultStatus },
historyPatient:{...defaultStatus}
}

const patientReducer = (state = initialState, action) => {
  const { type, payload } = action

  switch (type) {
    
    case FETCH_LIST_PATIENTS_REQUEST:
      return {
        ...state,
        fetchListPatients: {
          ...state.fetchListPatients,
          inProgress: true,
          error: null
        }
      }
    case FETCH_LIST_PATIENTS_SUCCESS:
      return {
        ...state,
        fetchListPatients: {
          ...state.fetchListPatients,
          inProgress: false,
          success: true,
          data: payload?.patients?.data
        },
      }
    case FETCH_LIST_PATIENTS_FAILURE:
      return {
        ...state,
        fetchListPatients: {
          ...state.fetchListPatients,
          inProgress: false,
          error: true,
          errorMessage: payload.error
        }
      }
      case FETCH_ALL_LIST_PATIENTS_REQUEST:
      return {
        ...state,
        fetchAllListPatients: {
          ...state.fetchAllListPatients,
          inProgress: true,
          error: null
        }
      }
    case FETCH_ALL_LIST_PATIENTS_SUCCESS:
      return {
        ...state,
        fetchAllListPatients: {
          ...state.fetchAllListPatients,
          inProgress: false,
          success: true,
          data: payload?.patients?.data
        },
      }
    case FETCH_ALL_LIST_PATIENTS_FAILURE:
      return {
        ...state,
        fetchAllListPatients: {
          ...state.fetchAllListPatients,
          inProgress: false,
          error: true,
          errorMessage: payload.error
        }
      }
      case HISTORY_PATIENTS_REQUEST:
        return {
          ...state,
          historyPatient: {
            ...state.fetchListPatients,
            inProgress: true,
            error: null
          }
        }
      case HISTORY_PATIENTS_SUCCESS:
        return {
          ...state,
          historyPatient: {
            ...state.fetchListPatients,
            inProgress: false,
            success: true,
            data: payload?.patients?.data
          },
        }
      case HISTORY_PATIENTS_FAILURE:
        return {
          ...state,
          historyPatient: {
            ...state.fetchListPatients,
            inProgress: false,
            error: true,
            errorMessage: payload.error
          }
        }
    
    case FETCH_PATIENT_REQUEST:
      return {
        ...state,
        fetchPatient: { ...state.fetchPatient, inProgress: true, error: null }
      }
    case FETCH_PATIENT_SUCCESS:
      return {
        ...state,
        fetchPatient: {
          ...state.fetchPatient,
          inProgress: false,
          success: true,
          data: payload?.patient?.data
         
        },
        currentPatient: { ...state.currentPatient, data: payload.patient }
      }
    case FETCH_PATIENT_FAILURE:
      return {
        ...state,
        fetchPatient: {
          ...state.fetchPatient,
          inProgress: false,
          error: true,
          errorMessage: payload.error
        }
      }

      case ADD_PATIENT_REQUEST:
        return {
          ...state,
          addPatient: { 
            ...state.addPatient, 
            inProgress: true, 
            success: false,
            error: null,
            errorMessage: null
          }
        };
      case ADD_PATIENT_SUCCESS:
        return {
          ...state,
          addPatient: {
            ...state.addPatient,
            inProgress: false,
            success: true,
            error: false,
            data: payload?.patient
          },
        };
      case ADD_PATIENT_FAILURE:
        return {
          ...state,
          addPatient: {
            ...state.addPatient,
            inProgress: false,
            success: false,
            error: true,
            errorMessage: payload?.errorMessage || null,
            ...payload
          }
        };
    // Edit patient
    case UPDATE_PATIENT_REQUEST:
      return {
        ...state,
        updatePatient: { ...state.updatePatient, inProgress: true, error: null }
      }
    case UPDATE_PATIENT_SUCCESS: {
      return {
        ...state,
        updatePatient: {
            ...state.addPatient,
            inProgress: false,
            success: true,
            data: payload?.patient
          },
      }
    }
    case UPDATE_PATIENT_FAILURE:
      return {
        ...state,
        updatePatient: {
            ...state.addPatient,
            inProgress: false,
            success: false,
            error: true,
            errorMessage: payload?.errorMessage || null,
            ...payload
          }
      }

    // Delete patient
    case DELETE_PATIENT_REQUEST:
      return {
        ...state,
        deletePatient: { ...state.deletePatient, inProgress: true, error: null }
      }
    case DELETE_PATIENT_SUCCESS:
      return {
        ...state,
        deletePatient: {
          ...state.deletePatient,
          inProgress: false,
          success: true
        },
        patients: {
          ...state.patients,
          data: state.patients.data.filter(
            patient => patient.id !== payload.patientId
          )
        },
        currentPatient:
          state.currentPatient.data?.id === payload.patientId
            ? { ...defaultStatus, data: null }
            : state.currentPatient
      }
    case DELETE_PATIENT_FAILURE:
      return {
        ...state,
        deletePatient: {
          ...state.deletePatient,
          inProgress: false,
          error: true,
          errorMessage: payload.error
        }
      }

    // Reset current patient
    case RESET_CURRENT_PATIENT:
      return { ...initialState }

    default:
      return state
  }
}

export default patientReducer
